module.exports = __webpack_public_path__ + "img/twitter_color.bf0a2f23.png";